/** 클래스 이름 합치기. 조건부 클래스가 원자마다 반복돼서 한 줄로 묶었다. */
export function cx(...parts: ReadonlyArray<string | false | undefined | null>): string {
  return parts.filter((p): p is string => typeof p === 'string' && p !== '').join(' ')
}
